import Link from "next/link";
import Image from "next/image";
import { ModuleColumn } from "@/components/module";
import { useI18n } from "next-localization";
import imgSolar from "@/img/marketplace/solar.jpg";

export default function CleanEnergyModule() {
  const { t } = useI18n();
  return (
    <ModuleColumn
      graphic={
        <Image
          src={imgSolar}
          alt="Illustration of solar farm"
          placeholder="blur"
        />
      }
      headline={`${t("common.Decarbonize")} your power`}
      className="module-clean-energy"
    >
      <p>
        Use Watershed to buy{" "}
        <Link href="/blog/clean-power-how-companies-decarbonize-electricity">
          clean power
        </Link>{" "}
        for your buildings, data centers, and remote workers. We vet projects to
        ensure impact, and help you match purchases with your local electricity
        grids.
      </p>
      <style jsx global>{`
        section.module-clean-energy {
          background-color: #e87154;
        }
        .module-clean-energy h3,
        .module-clean-energy a {
          color: #fff;
        }
        .module-clean-energy p {
          color: #fdf3d8;
        }
      `}</style>
    </ModuleColumn>
  );
}
